import {
    MobileDepositBonusContainerStyled,
    MobileDepositBonusContentStyled,
    MobileDepositBonusStyled,
    MobileDepositBonusTimeStyled
} from "./styled/MobileDepositBonusStyled";
import { Button } from "react-bootstrap";
import { useCallback } from "react";
import { useBonusContext } from "../../Bonus/bonusContext";
import { BinIcon } from "../../../components/icon/Icon";
import { BonusTime } from "../../Bonus/components/BonusTime.jsx";
import { useGTMEvent } from "../../GoogleTagManager/googleTagManagerHooks";
import ToAppButton from "../../../components/ToAppButton/ToAppButton";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { getAbTestMobileDepositBonusPrimaryButton } from "../../AbTests/abTestsSelectors";
import { useMaxHeightMediaQuery } from "../../../components/responsive/responsive-hooks";
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext.js";

const MobileDepositBonusTime = ({time}) => (
        <MobileDepositBonusTimeStyled>
            <BinIcon name="IcStopwatch" style={{fontSize: '24px'}}/>
            <div>
                {time}
            </div>
        </MobileDepositBonusTimeStyled>
)

const GetAppButton = ({className, variant}) => {
    const {getLangPath} = useLangContext();
    const {pushGtmEvent} = useGTMEvent({module: 'WelcomeDepositBonus'});
    const isSmall = useMaxHeightMediaQuery(560);

    const handleGetAppClick = useCallback(() => {
        pushGtmEvent({button: 'GoTrading', event: 'click'});
    }, [pushGtmEvent]);

    return (
            <ToAppButton>
                <Button
                        className={className}
                        size={isSmall ? 'sm' : 'lg'}
                        variant={variant}
                        onClick={handleGetAppClick}
                >
                    {getLangPath('onboarding.get_app_button')}
                </Button>
            </ToAppButton>
    );
}

const MobileDepositBonus = (props) => {
    const {getLangPath} = useLangContext();
    const {bonusAvailableSecondsLeft} = useBonusContext();
    return (
            <MobileDepositBonusStyled>
                <MobileDepositBonusContainerStyled>
                    <MobileDepositBonusContentStyled>
                        <h1 className="mb-0">{getLangPath('bonuses.banner_title')}</h1>
                        {!!bonusAvailableSecondsLeft && <BonusTime seconds={bonusAvailableSecondsLeft}>
                            <MobileDepositBonusTime/>
                        </BonusTime>}
                        <p className="mt-3">{getLangPath('bonuses.banner_description')}</p>
                    </MobileDepositBonusContentStyled>
                    <div className="d-flex flex-column">
                        <GetAppButton variant="primary"/>
                    </div>
                </MobileDepositBonusContainerStyled>
            </MobileDepositBonusStyled>
    )
}

const mapStateToProps = createStructuredSelector({
    abTestPrimaryButton: getAbTestMobileDepositBonusPrimaryButton,
});

export default connect(mapStateToProps)(MobileDepositBonus);
